import SectionHeader from './SectionHeader';

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/FormElements/SectionHeader/index.js